import React from 'react';
import { Check } from 'lucide-react';
import { BRAND_GREEN, BOOK_DEMO_URL, Cta, GET_STARTED_URL } from './shared';

const START_REASSURANCES = [
  'No contracts or commitments.',
  'No hidden fees.',
  'Upgrade or downgrade anytime.',
];

/** Dark closing band: partnership summary plus the primary CTA pair. */
const CtaSection = () => (
  <section aria-labelledby="inshur-cta-heading" className="ilp-cta-band ilp-cta-dark-band">
    <div className="ilp-cta-band-inner">
      <p className="ilp-cta-band-eyebrow">Rentid &amp; INSHUR Partnership</p>

      <h2 id="inshur-cta-heading" className="ilp-cta-band-title">
        Rentid for rentals. INSHUR for insurance.
      </h2>

      <p className="ilp-cta-band-sub">Free to start. Only pay when rented. Subscribe and save.</p>

      <ul className="ilp-cta-band-list">
        {START_REASSURANCES.map((item) => (
          <li key={item}>
            <Check className="ilp-cta-band-check" style={{ color: BRAND_GREEN }} aria-hidden="true" />
            {item}
          </li>
        ))}
      </ul>

      <div className="ilp-cta-row">
        <Cta href={GET_STARTED_URL} label="Get Started" />
        <Cta href={BOOK_DEMO_URL} label="Book Demo" tone="dark" />
      </div>
    </div>
  </section>
);

export default CtaSection;
